import { supabase } from '../lib/supabase';
import { comMotivo, erroColunaMotivoAusente } from '../lib/alteracoesCadastro';

// Gravação com o motivo junto (coluna de passagem `motivo_alteracao`, migration
// 20261029180000): o gatilho registra a mudança com quem, quando e o motivo, e o
// Faturamento vê no cálculo e na emissão do boleto. Banco ainda sem a migration
// recusa a coluna — aí grava sem o motivo, para não travar ninguém.
export async function gravarComMotivo<T>(
    gravar: (payload: Record<string, unknown>) => PromiseLike<{ data: T; error: any }>,
    payload: Record<string, unknown>,
    motivo?: string | null,
): Promise<{ data: T; error: any }> {
    const r = await gravar(comMotivo(payload, motivo));
    if (r.error && motivo && erroColunaMotivoAusente(r.error)) return gravar(payload);
    return r;
}

/** Update de uma UC com o motivo da mudança. */
export function atualizarUcComMotivo(ucId: number | string, payload: Record<string, unknown>, motivo?: string | null) {
    return gravarComMotivo(p => supabase.from('unidades_consumidoras').update(p).eq('id', ucId), payload, motivo);
}
